export default ({...props}) => {
  const {palette, primaryButton, secondaryButton, panelHighlight, rem, space, unit, size, themeGrey, fontWeight, shape} =
    props.theme
  const {lighter, normal, medium, bold} = fontWeight
  const {borderRadius} = shape
  return `
    line-height: 1em;
    color: ${palette.text.primary};
    margin-bottom: ${space(2)}px;

    &[ap_type="h1"]{
        font-weight:${normal};
        font-size:${rem(3.75)};
        letter-spacing:${unit(2)}px;
    }
    &[ap_type="h2"]{
        font-weight:${normal};
        font-size:${rem(3.0265)};
        letter-spacing:${unit(0)}px;
    }
    &[ap_type="h3"]{
        font-weight:${normal};
        font-size:${rem(2.625)};
        letter-spacing:${unit(0)}px;
    }
    &[ap_type="h4"]{
        font-weight:${normal};
        font-size:${rem(2.3125)};
        letter-spacing:${unit(0.25)}px;
    }
    &[ap_type="h5"]{
        font-weight:${normal};
        font-size:${rem(2)};
        letter-spacing:${unit(0.25)}px;
        text-transform:capitalize;
    }
    &[ap_type="h6"]{
        font-weight:${normal};
        font-size:${rem(1.75)};
        font-size: 28px;
        letter-spacing:${unit(0)}px;
        text-transform:capitalize;
    }
    &[ap_type="h7"]{
        font-weight:${normal};
        font-size:${rem(1.53125)};
        letter-spacing:${unit(0.15)}px;
        text-transform:capitalize;
    }
    &[ap_type="title"]{
        font-weight:${bold};
        font-size:${rem(1.3125)};
        letter-spacing:${unit(0.15)}px;
        text-transform:capitalize;
    }
    &[ap_type="subtitle"]{
        font-weight:${medium};
        font-size:${rem(1.15625)};
        letter-spacing:${unit(0.15)}px;
        text-transform:titlecase;
    }
    &[ap_type="label1"]{
        font-weight:${medium};
        font-size:${rem(1)};
        letter-spacing:${unit(0.5)}px;
        text-transform:titlecase;
    }
    &[ap_type="label2"]{
        font-weight:${normal};
        font-size:${rem(0.75)};
        letter-spacing:${unit(0.4)}px;
        text-transform:capitalize;
    }
    &[ap_type="body"]{
        font-weight:${normal};
        font-size:${rem(1)};
        letter-spacing:${unit(0.25)}px;
        text-transform:none;
    }
    &[ap_type="body2"]{
        font-weight:${normal};
        font-size:${rem(0.875)};
        letter-spacing:${unit(0.25)}px;
        text-transform:none;
    }
    &[ap_type="button"]{
        font-weight:${medium};
        font-size:${rem(0.875)};
        letter-spacing:${unit(1.25)}px;
        text-transform:uppercase;
    }
     &[ahd_type='currentStep'] {
        font-weight: ${bold};
        font-size: ${rem(0.75)};
        line-height: ${size(2)}px;
        color: ${themeGrey.medium_emphasis_grey};
    } 
    &[ahd_type='calDate'] { 
        font-weight: ${normal};
        font-size: ${rem(1)};
        line-height: ${size(2.5)}px;
        color: ${themeGrey.high_emphasis_grey};
        text-transform:capitalize;
        margin-bottom: 0;
    } 
    &[ahd_type='calDateD'] { 
        font-weight: ${normal};
        font-size: ${rem(1)};
        line-height: ${size(2.5)}px;
        color: ${themeGrey.disabled_grey};
        margin-bottom: 0;
    } 
    &[ahd_type='calDateS'] {
        font-weight: ${medium};
        font-size: ${rem(1)};
        line-height: ${size(2.5)}px;
        color: ${primaryButton.foreground};
        background-color: ${primaryButton.background};
        display: inline-block;
        padding: ${space(0.5)}px;
        margin-bottom: 0;
     } 
    &[ahd_type='fData'] {
        font-weight: ${normal};
        font-size: ${rem(0.9375)};
        line-height: ${size(2.5)}px;
        letter-spacing: ${space(-0.02875)}px;
        color: ${themeGrey.medium_emphasis_grey};
     } 
    &[ahd_type='formLabel'] {
        font-weight: ${medium};
        font-size: ${rem(0.875)};
        line-height: ${size(2.375)}px;
        letter-spacing: ${space(0.175)}px;
        color: ${themeGrey.high_emphasis_grey};
        text-transform: uppercase;
     } 
    &[ahd_type='navLink'] {
        font-weight: ${normal};
        font-size: ${rem(0.9375)};
        line-height: ${size(2.5)}px;
        letter-spacing: ${space(-0.02875)}px;
        color: ${panelHighlight.foreground};
        text-transform: lowercase;
        margin: 0;
     } 
     &[ahd_type='pButton'] {
        font-weight: ${normal};
        font-size: ${rem(1.0625)};
        letter-spacing: ${space(-0.03875)}px;
        color: ${primaryButton.foreground};
        display:flex;
        background-color: ${primaryButton.background};
        margin-bottom: 0px;
        padding: ${size(1)}px ${size(2)}px;
        border-radius: ${borderRadius}px;
     } 
    &[ahd_type='h7'] {
        font-weight: ${medium};
        font-size: ${rem(1.75)};
        line-height: ${size(3.75)}px;
        letter-spacing: ${space(-0.0275)}px;
        color: ${themeGrey.high_emphasis_grey};
     } 
    &[ahd_type='h6'] {
        font-weight: ${lighter};
        font-size: ${rem(1.75)};
        line-height: ${size(2.5)}px;
        color: ${themeGrey.high_emphasis_grey};
     } 
    &[ahd_type='popHeader'] { 
        font-weight: ${bold};
        font-size: ${rem(1.375)};
        line-height: ${size(3.625)}px;
        letter-spacing: ${space(-0.025)}px;
        color:${themeGrey.medium_emphasis_grey};
    } 
    &[ahd_type='regText'] { 
        font-weight: ${normal};
        font-size: ${rem(1.0625)};
        line-height: ${size(2.875)}px;
        letter-spacing: ${space(0.0275)}px;
        color: ${themeGrey.medium_emphasis_grey};
        @media screen and (max-width: 768px){ 
            font-size: ${rem(0.9375)};
            }
    } 
    &[ahd_type='sButton'] {
        font-weight: ${normal};
        font-size: ${rem(1.0625)};
        letter-spacing: ${space(-0.03875)}px;
        color: ${secondaryButton.foreground};
        display:flex;
        margin-bottom: 0px;
        border: 1px solid ${secondaryButton.border};
         padding: ${size(1)}px ${size(2)}px;
        border-radius: ${borderRadius}px;
     } 
    &[ahd_type='sData'] {
        font-weight: ${normal};
        font-size: ${rem(0.875)};
        line-height: ${size(2.375)}px;
        letter-spacing: ${space(0.025)}px;
        color: ${themeGrey.high_emphasis_grey}
     } 

     &[ahd_type='sData inline'] {
        display: inline-block;
        font-weight: ${normal};
        font-size: ${rem(0.875)};
        line-height: ${size(2.375)}px;
        letter-spacing: ${space(0.025)}px;
        color: ${themeGrey.high_emphasis_grey};
        margin-bottom: 0px;
     } 

    &[ahd_type='sLabel'] {
        font-weight: ${medium};
        font-size: ${rem(0.875)};
        line-height: ${size(2.375)}px;
        letter-spacing: ${space(0.06)}px;
        color: ${themeGrey.high_emphasis_grey};
     } 
    &[ahd_type='sLink'] {
        font-weight: ${normal};
        font-size: ${rem(0.875)};
        line-height: ${size(2.375)}px;
        letter-spacing: ${space(0.025)}px;
        color: ${panelHighlight.foreground};
    }
    &[ahd_type='mLink'] {
        font-weight: ${medium};
        font-size: ${rem(0.875)};
        line-height: ${size(1.75)}px;
        letter-spacing: ${space(0.025)}px;
        color: ${panelHighlight.foreground}};
    }
    &[ahd_type='selectableDate'] {
        font-weight: ${bold};
        font-size: ${rem(1)};
        line-height: ${size(2.625)}px;
        letter-spacing: ${space(0.02625)}px;
        color: ${themeGrey.medium_emphasis_grey};
     }
    &[ahd_type='selectableTime'] { 
        font-weight: ${normal};
        font-size: ${rem(1)};
        line-height: ${size(2.625)}px;
        letter-spacing: ${space(0.02625)}px;
        color: ${themeGrey.medium_emphasis_grey};
    }
    &[ahd_type='selectedDate'] {
        font-weight: ${bold};
        font-size: ${rem(1)};
        line-height: ${size(2.625)}px;
        background-color:${primaryButton.background}
        letter-spacing: ${space(0.02625)}px;
        color: ${primaryButton.foreground};
     }
    &[ahd_type='selectedTime'] { 
        font-weight: ${normal};
        font-size: ${rem(1)};
        line-height: ${size(2.625)}px;
        background-color:${primaryButton.background}
        letter-spacing: ${space(0.02625)}px;
        color: ${primaryButton.foreground};
    }
    &[ahd_type='product'] { 
        font-weight: ${medium};
        font-size: ${rem(1.0625)};
        line-height: ${size(2.875)}px;
        letter-spacing: ${space(0.0275)}px;
        color: ${themeGrey.high_emphasis_grey};
        @media screen and (max-width: 768px){ 
            font-size: ${rem(0.9375)};
            }
    }
    &[ahd_type='subheading'] { 
        font-weight: ${bold};
        font-size: ${rem(1.125)};
        line-height: ${size(3)}px;
        letter-spacing: ${space(0.03125)}px;
        color: ${themeGrey.high_emphasis_grey};
        margin-bottom: 0;
    }
    &[ahd_type='status'] { 
        font-weight: ${medium};
        font-size: ${rem(1.0625)};
        line-height: ${size(2.875)}px;
        letter-spacing: ${space(0.0275)}px;
        color: ${themeGrey.high_emphasis_grey};
    }
    &[ahd_type='step'] {
        font-weight: ${normal};
        font-size: ${rem(0.76)};
        line-height: ${size(2)}px;
        color: ${themeGrey.medium_emphasis_grey};
     } 
    &[ahd_type='uid']{
        font-weight: ${bold};
        font-size: ${rem(1.125)};
        line-height: ${rem(0.875)};
        letter-spacing: ${space(0.03125)}px;
        color: ${panelHighlight.foreground};
    }
    &[ap_color="error"] {
        color: ${palette.error.main};
    }
    `
}
